import { useReportEarningHistoryList } from '@/api/gen'
import { DataTable } from '@/components/data-table'
import { tableQueryState } from '@/components/table-query-state'
import { useAuth } from '@/hooks/use-auth'
import { useEarningsHistoryTableCols } from '@/pages/rewards/hooks/use-earning-history-table-cols'

import { HISTORY_QUERY_OPTIONS, PAGE_SIZE_OPTIONS } from './constants'
import { useHistoryPagination } from './use-history-pagination'

export const EarningsHistoryTable = () => {
  const columns = useEarningsHistoryTableCols()
  const { isAuthorized, isInitialized } = useAuth()
  const { pagination, onPaginationChange, params } = useHistoryPagination()

  const { data, error, isError, isFetching, refetch } = useReportEarningHistoryList(params, {
    query: { ...HISTORY_QUERY_OPTIONS, enabled: isAuthorized },
  })

  return (
    <DataTable
      manualPagination
      columns={columns}
      data={data?.results ?? []}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      pagination={pagination}
      rowCount={data?.count ?? 0}
      onPaginationChange={onPaginationChange}
      {...tableQueryState({
        error,
        hasData: data !== undefined,
        isError,
        isFetching,
        isInitialized,
        refetch,
      })}
      // Row identity is the position in the page, as it was before: these rows carry no id of
      // their own. Safe only because nothing selects them — a selection would reattach to the
      // wrong record on the next page.
      getRowId={(_row, index) => String(index)}
    />
  )
}
